// AiAgentName.js
// Purpose: Manages the details and configuration of a specific AI agent, including editing and viewing agent activity.
// Logic: Uses React hooks and route parameters to fetch and display agent-specific data and handle related UI state.

import { useEffect, useState, useRef, useCallback } from "react";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  Button,
  Modal,
  Drawer,
  Tabs,
  Label,
  TextInput,
  Textarea,
} from "flowbite-react";
import axios from "axios";
import useCommonApi from "../hooks/common-apis";
import EditableTable from "../components/EditableTable";
import EditableTableAgent from "../components/EditableTableAgent";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import Loader from "../components/Loader";
import { socketService } from "../components/socketService";
import FailureModal from "../components/FailureModal";
import { toast } from "react-toastify";
import Chat from "./Chat";
import MonthlyCalenderTable from "../components/MonthlyCalenderTable";
import dayjs from "dayjs";
import { Select } from "antd";
import { Tooltip } from "react-tooltip";
import MonthlyCalenderComponent from "../components/MonthlyCalenderComponent";
import { clog } from "../lib/utils";

function AiAgentName() {
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;
  const notify = (message, type) =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });

  clog(params, "params");
  const [openModal, setOpenModal] = useState();
  const modalRef = useRef(null);
  const path = useLocation();
  const [modelopen, setModelopen] = useState(false);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const [taskData, settaskData] = useState({
    content: "",
    knowledge_id: "",
    keywordSeeds: "",
    workspace_id: "",
    content_type: "",
    word_count: "",
    plagiarism_percentage: "",
    variation: "",
    post_frequency: "",
    content_repurposer: "",
  });
  const [wordPressDetails, setwordPressDetails] = useState({});
  const [rerunPopup, setrerunPopup] = useState(false);

  const [knowLedgeBaseList, setknowLedgeBaseList] = useState([]);
  const [agentResponseData, setagentResponseData] = useState({});
  const { getKnowledgeBaseList, checkTwitterAccess } = useCommonApi();
  const [twitterProfile, setTwitterProfile] = useState({});
  const [isChecking, setisChecking] = useState(false);
  const [loading, setloading] = useState(false);
  const [monthlyAssign, setmonthlyAssign] = useState("monthlyCalender");
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };

  const moreLink = (env, id) => {
    if (!env.target.matches(".active")) {
      document.querySelectorAll(".nav-toggle").forEach((e) => {
        e.classList.remove("active");
      });
      document.querySelectorAll(".navmore-link").forEach((e) => {
        e.classList.remove("active");
      });
      env.target.classList.add("active");
      document.getElementById(id).classList.add("active");
    } else {
      env.target.classList.remove("active");
      document.getElementById(id).classList.remove("active");
    }
  };
  const menuToggle = () => {
    document.body.classList.toggle("shrink-menu");
  };
  // tabs
  const [activeTab, setActiveTab] = useState("tab2");

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    if (tab === "tab3") {
      setAgentContents([]);
      setOffset(0);
      setHasNextPage(false);
      fetchAgentContents(0);
    }
    setActiveTab(tab);
  };

  //
  const [tags, setTags] = useState([]);
  const [tagskeywords, setTagskeywords] = useState([]);
  const [tagsrepurposer, setTagsrepurposer] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [inputValuekeywords, setInputValuekeywords] = useState("");
  const [inputValuerepurposer, setInputValuerepurposer] = useState("");
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setTags([...tags, inputValue.trim()]);
      setInputValue(""); // Clear input after adding the tag
    } else {
      if (e.key === "Enter" && inputValue.trim() === "") {
        e.preventDefault();
        return;
      }
      if (e.key === "Backspace" && inputValue === "") {
        removeTag(tags.length - 1);
      }
    }
  };
  const handleKeyDownkeywords = (e) => {
    if (e.key === "Enter" && inputValuekeywords.trim() !== "") {
      e.preventDefault();
      setTagskeywords([...tagskeywords, inputValuekeywords.trim()]);
      setInputValuekeywords(""); // Clear input after adding the tag
    } else {
      if (e.key === "Enter" && inputValuekeywords.trim() === "") {
        e.preventDefault();
        return;
      }
      if (e.key === "Backspace" && inputValuekeywords === "") {
        removeTagkeywords(tagskeywords.length - 1);
      }
    }
  };
  const handleKeyDownrepurposer = (e) => {
    if (e.key === "Enter" && inputValuerepurposer.trim() !== "") {
      e.preventDefault();
      setTagsrepurposer([...tagsrepurposer, inputValuerepurposer.trim()]);
      setInputValuerepurposer(""); // Clear input after adding the tag
    } else {
      if (e.key === "Enter" && inputValuerepurposer.trim() === "") {
        e.preventDefault();
        return;
      }
      if (e.key === "Backspace" && inputValuerepurposer === "") {
        removeTagrepurposer(tagsrepurposer.length - 1);
      }
    }
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, index) => index !== indexToRemove));
  };
  const removeTagkeywords = (indexToRemove) => {
    setTagskeywords(tagskeywords.filter((_, index) => index !== indexToRemove));
  };
  const removeTagrepurposer = (indexToRemove) => {
    setTagsrepurposer(
      tagsrepurposer.filter((_, index) => index !== indexToRemove)
    );
  };
  const handleChange = (e) => {
    settaskData({ ...taskData, [e.target.id]: e.target.value });
  };
  let login_data = JSON.parse(localStorage.getItem("login_data"));
  async function handleTwitterLogin() {
    try {
      window.open(
        `${process.env.REACT_APP_BASE_SIGNIN_URL}/auth/twitter/${
          login_data?.resp_user?.id
        }?redirect_uri=${window.location.origin + window.location.pathname}`,
        "_self"
      );
    } catch (error) {
      console.error("Error initiating Twitter login", error);
    }
  }
  const getAgentData = async (content_id) => {
    setloading(true);
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let data = {
      ...taskData,
      content_repurposer: tagsrepurposer.join(","),
      workspace_id: login_data?.resp_user?.workspace_id?.toString(),
      knowledge_id:
        taskData?.knowledge_id === "" ? "" : parseInt(taskData?.knowledge_id),
      content: taskData?.content,
      keywordSeeds: taskData?.keywordSeeds,
      content_type: taskData?.content_type,
      word_count: taskData?.word_count,
      plagiarism_percentage: taskData?.plagiarism_percentage,
      variation: tags.join(","),
      post_frequency: taskData?.post_frequency,
      emp_id: JSON.parse(localStorage.getItem("selected_agent"))?.id,
    };
    if (content_id) {
      data["content_id"] = content_id;
    }
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/keyword_ideas`,
        // url: "https://agent-mark.dev-vison.infiniticube.in/generate_content",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        // data: {
        //   model: "model_name_v0.1",
        //   messages: [
        //     {
        //       role: "user",
        //       content: taskData?.content || "",
        //     },
        //   ],
        //   stream: false,
        //   request_info: {
        //     user_id: login_data?.resp_user?.id,
        //     workspace_id: login_data?.resp_user?.workspace_id,
        //     knowledge_id:
        //       taskData?.knowledge_id === ""
        //         ? ""
        //         : parseInt(taskData?.knowledge_id),
        //     files: "",
        //     // user_id: 13,
        //     // workspace_id: 0,
        //     // knowledge_id: 31,
        //     // files: ["file2"],
        //   },
        // },
        data: data,
      });
      setloading(false);
      clog(response?.data);
      if (!response.data.error) {
        setagentResponseData(response?.data || {});
        notify(response?.data?.message, "success");
        // setActiveTab("tab3");
        handleTabClick("tab3");
        window?.scrollTo(0, 0);
        settaskData({
          content: "",
          knowledge_id: "",
          keywordSeeds: "",
          workspace_id: "",
          content_type: "",
          word_count: "",
          plagiarism_percentage: "",
          variation: "",
          post_frequency: "",
          content_repurposer: "",
        });
        setTags([]);
        setTagskeywords([]);
        setTagsrepurposer([]);
        setrerunPopup(false);
      } else {
        // clog(response.data.message, "response.data.message");
        setsuccessFailureMessage(response.data.message);
        setopenFailureModal("dismissible");
      }
    } catch (error) {
      setloading(false);
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
      }
    }
  };
  clog(taskData, "task data");
  const getKnowLedgeBaseListFn = async () => {
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let workspace_id = login_data?.resp_user?.workspace_id;
    if (!workspace_id) {
      return;
    }
    let response = await getKnowledgeBaseList(workspace_id);
    if (response) {
      setknowLedgeBaseList(response?.data || []);
    } else {
      setknowLedgeBaseList([]);
    }
  };
  async function checkGscAccess() {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/google/search/website`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        params: {
          user_id: JSON.parse(localStorage.getItem("login_data"))?.resp_user
            ?.id,
        },
      });
      // clog(response, "response");
      if (!response.data.error) {
        if (response.data?.data?.access_token) {
          localStorage.setItem(
            "google_search_console_access",
            JSON.stringify(response.data?.data)
          );
          localStorage.setItem("gsc_website", response.data?.data?.profile_url);
          // setGsc_website(response.data?.data?.profile_url);
        } else {
          localStorage.removeItem("google_search_console_access");
          localStorage.removeItem("gsc_website");

          // setGsc_website(null);
        }
      } else {
        localStorage.removeItem("google_search_console_access");
        localStorage.removeItem("gsc_website");

        // setGsc_website(null);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      localStorage.removeItem("google_search_console_access");
      localStorage.removeItem("gsc_website");

      // setGsc_website(null);
    }
  }
  useEffect(() => {
    getKnowLedgeBaseListFn();
    checkGscAccess();
  }, []);
  clog(agentResponseData, "agentResponseData");
  const [agentContents, setAgentContents] = useState([]);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [offset, setOffset] = useState(0);
  const [loadingAgents, setLoadingAgents] = useState(false);
  const [loadingIndividualAgent, setloadingIndividualAgent] = useState("");

  // Modified fetchAgentContents function
  const fetchAgentContents = async (currentOffset = 0) => {
    const query = `
      query($limit: Int, $offset: Int, $emp_id: String) {
        getagentcontents(limit: $limit, offset: $offset, emp_id: $emp_id) {
          agentcontents {
            id
            input_content
            user_id
            knowledge_id
            workspace_id
            keywordseeds
            model
            title
            content
            review
            content_type
            word_count
            plagiarism_percentage
            variation
            post_frequency
            content_repurposer
            total_cost
            gpt_cost
            prompt_tokens
            completion_tokens
            total_tokens
            status
            emp_id
            linkedin
            twitter
            cmspublished
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    `;

    try {
      setLoadingAgents(true);
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/graphql`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          query,
          variables: {
            limit: 20,
            offset: currentOffset,
            emp_id: JSON.parse(
              localStorage.getItem("selected_agent")
            )?.id?.toString(),
          },
        },
      });

      const { agentcontents, pageInfo } = response.data.data.getagentcontents;
      setAgentContents((prev) =>
        currentOffset === 0 ? agentcontents : [...prev, ...agentcontents]
      );
      setHasNextPage(pageInfo.hasNextPage);
      setOffset(currentOffset + 20);
    } catch (error) {
      console.error("Error fetching agent contents:", error);
    } finally {
      setLoadingAgents(false);
    }
  };

  // Create observer reference
  const observerRef = useRef();

  // Create callback for intersection observer
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;

      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchAgentContents(offset);
        }
      });

      if (node) {
        observerRef.current.observe(node);
      }
    },
    [loading, hasNextPage, offset]
  );

  const fetchIndividualAgentContent = async (id) => {
    const query = `
      query($id: String!) {
        getagentcontent(id: $id) {
          id
          input_content
          user_id
          knowledge_id
          workspace_id
          keywordseeds
          model
          title
          content
          review
          content_type
          word_count
          plagiarism_percentage
          variation
          post_frequency
          content_repurposer
          total_cost
          gpt_cost
          prompt_tokens
          completion_tokens
          total_tokens
          status
          emp_id
          linkedin
          twitter
          cmspublished
        }
      }`;
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/graphql`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          query,
          variables: {
            id,
          },
        },
      });
      clog(response.data);
      const { getagentcontent } = response.data.data;
      setAgentContents((prev) =>
        prev?.map((item) => {
          if (item.id === id) {
            return getagentcontent;
          }
          return item;
        })
      );
    } catch (error) {
      console.error("Error fetching individual agent content:", error);
    } finally {
      setloadingIndividualAgent("");
    }
  };

  // Clean up observer
  useEffect(() => {
    // fetchIndividualAgentContent("677e0fecd4479f74c8b2dadc");
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);
  useEffect(() => {
    if (!socketService.isConnected()) {
      socketService.initialize();
    }
    // Handle notifications
    const handleNotification = (data) => {
      //example data
      // {
      //   contents:'Job Success for Manual agent process ',
      //   knowledge_id:knowledge_id,
      //   content_id: content_id.toString()
      //}
      setTimeout(() => {
        setloadingIndividualAgent(data?.content_id);
        fetchIndividualAgentContent(data?.content_id);
      }, 50);
      clog("AiAgentName notification:", data);
    };

    socketService.on("keyword_notification", handleNotification);

    return () => {
      socketService.off("keyword_notification", handleNotification);
    };
  }, []);
  // useEffect(() => {
  //   checkTwitterAccess(setTwitterProfile, setisChecking);
  //   const searchParams = new URLSearchParams(window.location.search);
  //   let success = searchParams.get("success");
  //   //parse success to bool
  //   success = success === "true" ? true : false;
  //   const error = searchParams.get("error");
  //   //if searchparams are present then update the twitter access token
  //   if (searchParams.has("success")) {
  //     if (!success) {
  //       clog("error from query", error);
  //       setopenFailureModal("dismissible");
  //       setsuccessFailureMessage(error);
  //     }
  //   }
  // }, []);
  const getWordPressPixel = async () => {
    // clog(id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/cms/getaccessdata/wordpress`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        setwordPressDetails({ ...response?.data?.data[0] });
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    }
  };
  const checkKnowledgeBase = () => {
    if (knowLedgeBaseList?.length === 0) {
      setopenFailureModal("dismissible");
      setsuccessFailureMessage("Please create knowledge base first");
    }
    return knowLedgeBaseList?.length > 0;
  };
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month()); // 0-indexed
  const [selectedYear, setSelectedYear] = useState(dayjs().year());

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    // You can fetch monthlyData here based on selected month
  };
  const handleYearChange = (value) => {
    if (selectedMonth > currentMonth && value === currentYear) {
      setSelectedMonth(currentMonth);
    }
    setSelectedYear(value);
    // Same: fetch/filter based on year if needed
  };
  const currentYear = dayjs().year();
  const currentMonth = dayjs().month(); // 0-indexed (January = 0)

  const monthOptions = dayjs.months().map((month, index) => ({
    label: month,
    value: index,
    disabled: selectedYear === currentYear && index > currentMonth, // disable future months
  }));

  const yearOptions = Array.from({ length: 5 }, (_, i) => {
    const year = currentYear - 4 + i;
    return { label: year.toString(), value: year };
  });
  // const [monthlyData, setmonthlyData] = useState([
  //   {
  //     title:
  //       "Unlocking Company Insights: Overcoming Technical Hurdles in Research",
  //     suggested_keywords: [
  //       "Company insights",
  //       "Research challenges",
  //       "Information retrieval",
  //       "Technical difficulties",
  //     ],
  //     painpoints: [
  //       "Inability to retrieve specific company information",
  //       "Lack of search performance metrics",
  //       "Need for clarity on company aspects of interest",
  //     ],
  //     intent: "Educational",
  //   },
  //   {
  //     title:
  //       "Navigating Research Challenges: Effective Strategies for Company Information Retrieval",
  //     suggested_keywords: [
  //       "Company research strategies",
  //       "Technical issues in research",
  //       "Information retrieval techniques",
  //       "Overcoming research hurdles",
  //     ],
  //     painpoints: [
  //       "Difficulty accessing specific company details",
  //       "Lack of insights from search performance metrics",
  //       "Challenges in drafting effective queries",
  //     ],
  //     intent: "Educational",
  //   },
  //   {
  //     title:
  //       "Mastering Company Research: Tactics for Overcoming Data Retrieval Obstacles",
  //     suggested_keywords: [
  //       "Company data retrieval",
  //       "Research tactics",
  //       "Data access challenges",
  //       "Effective research methods",
  //     ],
  //     painpoints: [
  //       "Technical difficulties with information retrieval",
  //       "Need for specific data points",
  //       "Inability to analyze search performance metrics",
  //     ],
  //     intent: "Educational",
  //   },
  //   {
  //     title:
  //       "Strategies for Effective Company Research: Conquering Technical Barriers",
  //     suggested_keywords: [
  //       "Effective company research",
  //       "Technical barriers in data retrieval",
  //       "Company inquiry strategies",
  //       "Overcoming research obstacles",
  //     ],
  //     painpoints: [
  //       "Challenges in retrieving specific company information",
  //       "Unavailability of detailed search performance data",
  //       "Need for clearer research pathways",
  //     ],
  //     intent: "Educational",
  //   },
  // ]);
  const [monthlyData, setmonthlyData] = useState([]);
  const [monthlyDataEdit, setmonthlyDataEdit] = useState([]);
  const [loadingMonthlyData, setloadingMonthlyData] = useState(false);
  const [generatingMonthlyData, setgeneratingMonthlyData] = useState(false);
  const [monthlyDataError, setmonthlyDataError] = useState("");
  const [savingTitle, setsavingTitle] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [approvingTitle, setapprovingTitle] = useState(false);
  const generateMonthlyCalenderData = async (code) => {
    setgeneratingMonthlyData(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/content_calendar`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {},
      });
      if (!response.data.error) {
        setmonthlyData(response.data?.data || []);
        setmonthlyDataEdit(response.data?.data || []);
        notify(response.data?.message, "success");
      } else {
        setmonthlyData([]);
        setmonthlyDataEdit([]);
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      setmonthlyData([]);
      setmonthlyDataEdit([]);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setgeneratingMonthlyData(false);
    }
  };
  const getMonthlyCalenderData = async (code) => {
    if (!localStorage.getItem("google_search_console_access")) {
      return;
    }
    setloadingMonthlyData(true);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_list`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          month: (selectedMonth + 1)?.toString()?.padStart(2, "0"),
          year: selectedYear?.toString(),
        },
      });
      if (!response.data.error) {
        let data = response.data?.data || [];
        let approvedIds = [];
        data?.forEach((item) => {
          if (item?.status && item?.status >= 2) {
            approvedIds.push(item?._id);
          }
        });
        setSelectedRows(approvedIds);
        setmonthlyData(data);
        setmonthlyDataEdit(data);
      } else {
        setmonthlyData([]);
        setmonthlyDataError(response?.data?.message);
      }
    } catch (error) {
      clog(error);
      setmonthlyData([]);
      setmonthlyDataError(error?.response?.data?.message || error?.message);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloadingMonthlyData(false);
    }
  };
  const saveMonthlyCalenderDataTitle = async (data, update) => {
    setsavingTitle(data?.id);
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_update`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response.data?.message, "success");
        setmonthlyData((prev) =>
          prev?.map((item) => {
            if (item._id === data?.id) {
              return {
                ...item,
                title: update === "title" ? data?.title : item?.title,
                suggested_keywords:
                  update === "keywords"
                    ? data?.suggested_keywords
                    : item?.suggested_keywords,
              };
              // return {
              //   ...item,
              //   title: data?.title,
              //   suggested_keywords: data?.suggested_keywords,
              // };
            }
            return item;
          })
        );
        setmonthlyDataEdit((prev) =>
          prev?.map((item) => {
            if (item._id === data?.id) {
              return {
                ...item,
                edit: false,
              };
            }
            return item;
          })
        );
      } else {
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setsavingTitle("");
    }
  };
  const selectedIdSet = new Set(selectedRows);
  const approvedId = monthlyData?.map((item) => {
    if (item?.status && item?.status >= 2) {
      return item?._id;
    }
  });
  const approvedIdSet = new Set(approvedId);

  let idsNotInApproved = selectedRows.filter((id) => !approvedIdSet.has(id));
  clog(idsNotInApproved, "idsNotInApproved");
  // check if any monthlyDataEdit has edit key is true;
  let hasEdit = monthlyDataEdit?.some((item) => item?.edit === true);
  const approveMonthlyCalenderData = async () => {
    if (idsNotInApproved?.length === 0) {
      return;
    }
    setapprovingTitle(true);
    let data = {
      updata: idsNotInApproved,
    };
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/googleads/calendar_approved`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response.data?.message, "success");
        setSelectedRows([]);
        getMonthlyCalenderData();
      } else {
        notify(response?.data?.message, "error");
      }
    } catch (error) {
      clog(error);
      notify(error?.response?.data?.message || error?.message, "error");
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setapprovingTitle(false);
    }
  };
  const getButtonText = () => {
    if (
      selectedRows?.length > 0 &&
      selectedRows?.length === monthlyData?.length
    ) {
      return "Approve All";
    } else {
      return "Approve";
    }
  };
  const disableAllactionsForYear = () => {
    // Except for current month and year all previous months and years should be disabled
    if (selectedYear === currentYear && selectedMonth === currentMonth) {
      return false;
    } else {
      return true;
    }
  };
  // Initial fetch
  useEffect(() => {
    fetchAgentContents(0);
    getWordPressPixel();
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    if (params.get("results")) {
      setActiveTab("tab3");
      params.delete("results");
    }
  }, []);
  clog(agentContents, "agentContents");

  return (
    <div className="mx-[-30px]">
      <div className=" mt-[-25px]">
        <div className="px-[30px] border-b border-[#E9EBF0] heading-box">
          <h4 className="text-[24px] font-[600] pb-4 pt-6">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/ai-agent");
              }}
            >
              AI Employee
            </span>{" "}
            {">"} {JSON.parse(localStorage.getItem("selected_agent"))?.emp_name}
          </h4>
          <div className="flex">
            <div className="agent-tabs mx-auto">
              {/* Tab Headers */}
              {/* <button
                className={`agenttab ${activeTab === "tab1" ? "active" : ""}`}
                onClick={() => handleTabClick("tab1")}
              >
                Configure
              </button> */}
              <button
                className={`agenttab ${activeTab === "tab2" ? "active" : ""}`}
                onClick={() => handleTabClick("tab2")}
              >
                Assign Task
              </button>
              <button
                className={`agenttab ${activeTab === "tab3" ? "active" : ""}`}
                onClick={() => {
                  // handleTabClick("tab3");
                  setActiveTab("tab3");
                  window?.scrollTo(0, 0);
                }}
              >
                Results
              </button>
              <button
                className={`agenttab ${activeTab === "tab4" ? "active" : ""}`}
                onClick={() => handleTabClick("tab4")}
              >
                Reporting
              </button>
            </div>
          </div>
        </div>
        <div className="flex agent-warpper">
          {/* {activeTab === "tab2" && ( */}
          <div
            className={`shadow-sm border-xl border-[#E9EBF0]l ai-agentaside ${
              activeTab === "tab2" ? "enter" : "exit w-0"
            }`}
          >
            <ul>
              <li>
                <NavLink
                  className="nav-link"
                  style={{
                    background:
                      monthlyAssign === "monthlyCalender" && "#e9f2ff",
                    color: monthlyAssign === "monthlyCalender" && "#097ba9",
                  }}
                  onClick={() => {
                    setActiveTab("tab2");
                    setmonthlyAssign("monthlyCalender");
                  }}
                >
                  <span>
                    <svg className="icon">
                      <use href="#icon_calendar2"></use>
                    </svg>
                  </span>
                  <strong>Monthly Calendar</strong>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="nav-link"
                  style={{
                    background: monthlyAssign === "manualAssign" && "#e9f2ff",
                    color: monthlyAssign === "manualAssign" && "#097ba9",
                  }}
                  onClick={() => {
                    setActiveTab("tab2");
                    setmonthlyAssign("manualAssign");
                  }}
                >
                  <span>
                    <svg className="icon mt-2">
                      <use href="#icon_manual_assign"></use>
                    </svg>

                    {/* <svg
                      className="icon"
                      viewBox="0 0 23 24"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_9140_172)">
                        <mask id="path-1-inside-1_9140_172" fill="white">
                          <path d="M17.4005 0H5.48183C5.08894 0.000454522 4.71228 0.154781 4.43448 0.429122C4.15667 0.703463 4.00042 1.07541 4 1.46337V12.4098C4.00397 12.4519 4.01426 12.4932 4.03053 12.5324C4.04716 12.5631 4.06745 12.5917 4.09098 12.6176L6.87498 15.2078C6.88869 15.2199 6.90395 15.2302 6.92037 15.2384C6.96588 15.2737 7.02221 15.2926 7.08009 15.2921H13.2812C13.9088 15.802 14.2082 16.0023 14.8478 16C15.3693 16.0025 15.8834 15.878 16.3445 15.6376C16.8057 15.3972 17.1998 15.0483 17.4919 14.6217C17.9188 14.0215 18.1532 13.3085 18.1645 12.5752V10.8122C18.1592 10.6583 18.1158 10.508 18.038 10.3746C17.9603 10.2411 17.8506 10.1285 17.7185 10.0466C17.5865 9.96473 17.4361 9.91606 17.2806 9.90487C17.1251 9.89369 16.9691 9.92033 16.8265 9.98246C16.7991 9.86023 16.7443 9.7456 16.6662 9.64697C16.5882 9.54833 16.4887 9.4682 16.3752 9.41242C16.2617 9.35665 16.137 9.32665 16.0103 9.32463C15.8835 9.32261 15.7579 9.34861 15.6426 9.40073C15.5464 9.21105 15.383 9.06283 15.1834 8.9842C14.9839 8.90556 14.7621 8.90198 14.56 8.97412V7.64774C14.5572 7.39965 14.4555 7.16264 14.277 6.98803C14.0985 6.81342 13.8575 6.71528 13.6062 6.71484C13.355 6.7144 13.1136 6.81171 12.9345 6.9857C12.7554 7.15968 12.6528 7.39634 12.6491 7.64442C12.6455 9.38369 12.6448 10.3677 12.6459 10.9277C12.4501 10.6971 12.1717 10.55 11.8688 10.5171C11.5658 10.4842 11.2617 10.5681 11.0199 10.7512C10.778 10.9343 10.617 11.2025 10.5705 11.4999C10.524 11.7973 10.5955 12.1009 10.7702 12.3475C11.3516 13.1811 11.9906 13.9741 12.6826 14.7207H7.36969V12.4098C7.3697 12.3722 7.36222 12.3351 7.34768 12.3004C7.33315 12.2657 7.31183 12.2342 7.28496 12.2077C7.25809 12.1812 7.22619 12.1601 7.19108 12.1458C7.15597 12.1314 7.11834 12.124 7.08034 12.1241H4.57865V1.46337C4.5789 1.2269 4.67413 1.00019 4.84345 0.832968C5.01277 0.665747 5.24235 0.571677 5.48182 0.571397H16.1704C15.9314 0.854291 15.8007 1.21106 15.801 1.57943C15.8017 1.5829 15.7996 3.42724 15.8017 3.43015V8.29531C15.8028 8.37034 15.8338 8.44193 15.8879 8.4946C15.9421 8.54727 16.015 8.57679 16.091 8.57679C16.167 8.57679 16.24 8.54726 16.2941 8.49459C16.3482 8.44192 16.3792 8.37033 16.3803 8.29529V3.71241H18.7107C18.7487 3.71242 18.7863 3.70503 18.8214 3.69068C18.8565 3.67633 18.8884 3.65528 18.9153 3.62875C18.9421 3.60222 18.9635 3.57072 18.978 3.53605C18.9925 3.50139 19 3.46423 19 3.42671V1.57943C18.9995 1.16069 18.8308 0.759245 18.531 0.463153C18.2311 0.167061 17.8246 0.000497537 17.4005 0ZM11.2694 11.3032C11.3232 11.2384 11.3902 11.1855 11.466 11.1479C11.5418 11.1103 11.6248 11.0889 11.7096 11.085C11.7943 11.0812 11.879 11.095 11.958 11.1256C12.037 11.1562 12.1086 11.2028 12.1681 11.2625L12.7329 11.8333C12.775 11.8744 12.8287 11.9018 12.887 11.9119C12.9452 11.922 13.0052 11.9144 13.059 11.8901C13.1127 11.8657 13.1577 11.8258 13.1879 11.7756C13.2181 11.7254 13.2321 11.6673 13.2281 11.609C13.223 11.474 13.2228 9.96123 13.2278 7.64551C13.2298 7.548 13.2706 7.45518 13.3413 7.38705C13.412 7.31891 13.5069 7.2809 13.6057 7.28119C13.7044 7.28149 13.7992 7.32006 13.8694 7.38862C13.9397 7.45718 13.9799 7.55023 13.9813 7.64776V11.513C13.9812 11.5506 13.9886 11.5879 14.0031 11.6227C14.0176 11.6574 14.0389 11.689 14.0658 11.7156C14.0926 11.7423 14.1246 11.7634 14.1597 11.7778C14.1949 11.7922 14.2326 11.7996 14.2707 11.7996C14.3087 11.7996 14.3464 11.7922 14.3816 11.7778C14.4168 11.7634 14.4487 11.7423 14.4756 11.7156C14.5025 11.689 14.5237 11.6574 14.5382 11.6227C14.5527 11.5879 14.5601 11.5506 14.56 11.513V9.78881C14.5615 9.71162 14.5936 9.63811 14.6495 9.58405C14.7053 9.53 14.7803 9.49972 14.8585 9.49973C14.9367 9.49973 15.0118 9.53001 15.0676 9.58407C15.1234 9.63812 15.1555 9.71164 15.157 9.78883V11.4045C15.1585 11.4793 15.1897 11.5505 15.2438 11.6029C15.2979 11.6553 15.3706 11.6846 15.4464 11.6846C15.5221 11.6846 15.5949 11.6553 15.649 11.6029C15.7031 11.5505 15.7342 11.4793 15.7357 11.4045V10.1551C15.7356 10.1207 15.7423 10.0865 15.7556 10.0547C15.7689 10.0228 15.7884 9.99383 15.813 9.96942C15.8377 9.94502 15.8669 9.92565 15.8992 9.91244C15.9314 9.89923 15.966 9.89242 16.0009 9.89242C16.0358 9.89242 16.0703 9.89923 16.1025 9.91244C16.1348 9.92565 16.164 9.94502 16.1887 9.96942C16.2133 9.99383 16.2328 10.0228 16.2461 10.0547C16.2594 10.0865 16.2661 10.1207 16.266 10.1551V11.491C16.2659 11.5286 16.2733 11.5658 16.2878 11.6006C16.3023 11.6354 16.3236 11.667 16.3504 11.6936C16.3773 11.7202 16.4093 11.7414 16.4444 11.7558C16.4796 11.7702 16.5173 11.7776 16.5554 11.7776C16.5934 11.7776 16.6311 11.7702 16.6663 11.7558C16.7015 11.7414 16.7334 11.7202 16.7603 11.6936C16.7872 11.667 16.8084 11.6354 16.8229 11.6006C16.8374 11.5658 16.8448 11.5286 16.8447 11.491V10.8122C16.8375 10.3741 17.5929 10.3739 17.5858 10.8122L17.586 12.5671C17.4789 14.9199 15.4653 15.5674 14.611 15.4151C13.9921 15.3677 12.7017 14.0665 11.2434 12.0189C11.1687 11.9129 11.1308 11.7858 11.1355 11.6568C11.1401 11.5277 11.1872 11.4036 11.2694 11.3032ZM6.79103 12.6955V14.3446L5.01831 12.6955H6.79103ZM18.4213 3.14101H16.3796V1.57943C16.3796 1.31208 16.4872 1.05568 16.6786 0.866638C16.8701 0.677594 17.1297 0.571391 17.4005 0.571391C17.6712 0.571391 17.9309 0.677594 18.1223 0.866638C18.3138 1.05568 18.4213 1.31208 18.4213 1.57943V3.14101Z"
                          fill="#2A2A2A"
                        />
                        <path
                          d="M14.636 4.15026V2.30466C14.6359 2.15317 14.5749 2.00793 14.4664 1.90081C14.3579 1.79369 14.2108 1.73343 14.0574 1.73326H6.3223C6.16888 1.73343 6.0218 1.79369 5.91332 1.90081C5.80484 2.00793 5.74381 2.15317 5.74364 2.30466V4.15026C5.74381 4.30175 5.80484 4.44699 5.91332 4.55411C6.0218 4.66123 6.16888 4.72148 6.3223 4.72165H14.0574C14.2108 4.72148 14.3579 4.66123 14.4664 4.55411C14.5749 4.44699 14.6359 4.30175 14.636 4.15026ZM6.3223 2.30466H14.0574L14.0577 4.15026H6.3223V2.30466Z"
                          fill="#2A2A2A"
                        />
                        <path
                          d="M12.6422 6.12276C12.6422 6.08524 12.6348 6.04808 12.6202 6.01342C12.6057 5.97875 12.5844 5.94725 12.5575 5.92071C12.5306 5.89418 12.4987 5.87313 12.4636 5.85878C12.4285 5.84442 12.3909 5.83704 12.3529 5.83705H6.03297C5.99489 5.83693 5.95717 5.84423 5.92196 5.85854C5.88675 5.87284 5.85475 5.89387 5.82779 5.92041C5.80082 5.94695 5.77943 5.97849 5.76483 6.01321C5.75023 6.04793 5.74272 6.08515 5.74272 6.12275C5.74272 6.16034 5.75023 6.19757 5.76483 6.23229C5.77943 6.26701 5.80082 6.29855 5.82779 6.32509C5.85475 6.35163 5.88675 6.37265 5.92196 6.38696C5.95717 6.40126 5.99489 6.40857 6.03297 6.40845H12.3529C12.3909 6.40846 12.4285 6.40107 12.4636 6.38672C12.4987 6.37237 12.5306 6.35132 12.5575 6.32479C12.5844 6.29826 12.6057 6.26677 12.6202 6.2321C12.6348 6.19744 12.6422 6.16028 12.6422 6.12276Z"
                          fill="#2A2A2A"
                        />
                        <path
                          d="M11.4923 8.54016C11.4923 8.50263 11.4848 8.46548 11.4702 8.43081C11.4557 8.39614 11.4344 8.36464 11.4075 8.33811C11.3807 8.31158 11.3488 8.29053 11.3136 8.27618C11.2785 8.26183 11.2409 8.25445 11.2029 8.25446H6.03297C5.99489 8.25434 5.95717 8.26164 5.92196 8.27595C5.88675 8.29025 5.85475 8.31128 5.82779 8.33782C5.80082 8.36436 5.77943 8.39589 5.76483 8.43062C5.75023 8.46534 5.74272 8.50256 5.74272 8.54016C5.74272 8.57775 5.75023 8.61498 5.76483 8.6497C5.77943 8.68442 5.80082 8.71595 5.82779 8.7425C5.85475 8.76904 5.88675 8.79006 5.92196 8.80437C5.95717 8.81867 5.99489 8.82597 6.03297 8.82585H11.2029C11.2409 8.82587 11.2785 8.81848 11.3137 8.80413C11.3488 8.78977 11.3807 8.76873 11.4075 8.7422C11.4344 8.71567 11.4557 8.68417 11.4703 8.6495C11.4848 8.61483 11.4923 8.57768 11.4923 8.54016Z"
                          fill="#2A2A2A"
                        />
                        <path
                          d="M6.03295 10.6719C5.95721 10.6733 5.88507 10.7041 5.83203 10.7575C5.77899 10.8109 5.74929 10.8828 5.74929 10.9576C5.74929 11.0324 5.779 11.1042 5.83204 11.1576C5.88509 11.211 5.95723 11.2418 6.03297 11.2433H9.66245C9.73819 11.2418 9.81033 11.211 9.86337 11.1576C9.91641 11.1042 9.94611 11.0324 9.94611 10.9576C9.94611 10.8827 9.9164 10.8109 9.86335 10.7575C9.81031 10.7041 9.73817 10.6733 9.66243 10.6719H6.03295Z"
                          fill="#2A2A2A"
                        />
                        <path
                          d="M17.4005 0H5.48183C5.08894 0.000454522 4.71228 0.154781 4.43448 0.429122C4.15667 0.703463 4.00042 1.07541 4 1.46337V12.4098C4.00397 12.4519 4.01426 12.4932 4.03053 12.5324C4.04716 12.5631 4.06745 12.5917 4.09098 12.6176L6.87498 15.2078C6.88869 15.2199 6.90395 15.2302 6.92037 15.2384C6.96588 15.2737 7.02221 15.2926 7.08009 15.2921H13.2812C13.9088 15.802 14.2082 16.0023 14.8478 16C15.3693 16.0025 15.8834 15.878 16.3445 15.6376C16.8057 15.3972 17.1998 15.0483 17.4919 14.6217C17.9188 14.0215 18.1532 13.3085 18.1645 12.5752V10.8122C18.1592 10.6583 18.1158 10.508 18.038 10.3746C17.9603 10.2411 17.8506 10.1285 17.7185 10.0466C17.5865 9.96473 17.4361 9.91606 17.2806 9.90487C17.1251 9.89369 16.9691 9.92033 16.8265 9.98246C16.7991 9.86023 16.7443 9.7456 16.6662 9.64697C16.5882 9.54833 16.4887 9.4682 16.3752 9.41242C16.2617 9.35665 16.137 9.32665 16.0103 9.32463C15.8835 9.32261 15.7579 9.34861 15.6426 9.40073C15.5464 9.21105 15.383 9.06283 15.1834 8.9842C14.9839 8.90556 14.7621 8.90198 14.56 8.97412V7.64774C14.5572 7.39965 14.4555 7.16264 14.277 6.98803C14.0985 6.81342 13.8575 6.71528 13.6062 6.71484C13.355 6.7144 13.1136 6.81171 12.9345 6.9857C12.7554 7.15968 12.6528 7.39634 12.6491 7.64442C12.6455 9.38369 12.6448 10.3677 12.6459 10.9277C12.4501 10.6971 12.1717 10.55 11.8688 10.5171C11.5658 10.4842 11.2617 10.5681 11.0199 10.7512C10.778 10.9343 10.617 11.2025 10.5705 11.4999C10.524 11.7973 10.5955 12.1009 10.7702 12.3475C11.3516 13.1811 11.9906 13.9741 12.6826 14.7207H7.36969V12.4098C7.3697 12.3722 7.36222 12.3351 7.34768 12.3004C7.33315 12.2657 7.31183 12.2342 7.28496 12.2077C7.25809 12.1812 7.22619 12.1601 7.19108 12.1458C7.15597 12.1314 7.11834 12.124 7.08034 12.1241H4.57865V1.46337C4.5789 1.2269 4.67413 1.00019 4.84345 0.832968C5.01277 0.665747 5.24235 0.571677 5.48182 0.571397H16.1704C15.9314 0.854291 15.8007 1.21106 15.801 1.57943C15.8017 1.5829 15.7996 3.42724 15.8017 3.43015V8.29531C15.8028 8.37034 15.8338 8.44193 15.8879 8.4946C15.9421 8.54727 16.015 8.57679 16.091 8.57679C16.167 8.57679 16.24 8.54726 16.2941 8.49459C16.3482 8.44192 16.3792 8.37033 16.3803 8.29529V3.71241H18.7107C18.7487 3.71242 18.7863 3.70503 18.8214 3.69068C18.8565 3.67633 18.8884 3.65528 18.9153 3.62875C18.9421 3.60222 18.9635 3.57072 18.978 3.53605C18.9925 3.50139 19 3.46423 19 3.42671V1.57943C18.9995 1.16069 18.8308 0.759245 18.531 0.463153C18.2311 0.167061 17.8246 0.000497537 17.4005 0ZM11.2694 11.3032C11.3232 11.2384 11.3902 11.1855 11.466 11.1479C11.5418 11.1103 11.6248 11.0889 11.7096 11.085C11.7943 11.0812 11.879 11.095 11.958 11.1256C12.037 11.1562 12.1086 11.2028 12.1681 11.2625L12.7329 11.8333C12.775 11.8744 12.8287 11.9018 12.887 11.9119C12.9452 11.922 13.0052 11.9144 13.059 11.8901C13.1127 11.8657 13.1577 11.8258 13.1879 11.7756C13.2181 11.7254 13.2321 11.6673 13.2281 11.609C13.223 11.474 13.2228 9.96123 13.2278 7.64551C13.2298 7.548 13.2706 7.45518 13.3413 7.38705C13.412 7.31891 13.5069 7.2809 13.6057 7.28119C13.7044 7.28149 13.7992 7.32006 13.8694 7.38862C13.9397 7.45718 13.9799 7.55023 13.9813 7.64776V11.513C13.9812 11.5506 13.9886 11.5879 14.0031 11.6227C14.0176 11.6574 14.0389 11.689 14.0658 11.7156C14.0926 11.7423 14.1246 11.7634 14.1597 11.7778C14.1949 11.7922 14.2326 11.7996 14.2707 11.7996C14.3087 11.7996 14.3464 11.7922 14.3816 11.7778C14.4168 11.7634 14.4487 11.7423 14.4756 11.7156C14.5025 11.689 14.5237 11.6574 14.5382 11.6227C14.5527 11.5879 14.5601 11.5506 14.56 11.513V9.78881C14.5615 9.71162 14.5936 9.63811 14.6495 9.58405C14.7053 9.53 14.7803 9.49972 14.8585 9.49973C14.9367 9.49973 15.0118 9.53001 15.0676 9.58407C15.1234 9.63812 15.1555 9.71164 15.157 9.78883V11.4045C15.1585 11.4793 15.1897 11.5505 15.2438 11.6029C15.2979 11.6553 15.3706 11.6846 15.4464 11.6846C15.5221 11.6846 15.5949 11.6553 15.649 11.6029C15.7031 11.5505 15.7342 11.4793 15.7357 11.4045V10.1551C15.7356 10.1207 15.7423 10.0865 15.7556 10.0547C15.7689 10.0228 15.7884 9.99383 15.813 9.96942C15.8377 9.94502 15.8669 9.92565 15.8992 9.91244C15.9314 9.89923 15.966 9.89242 16.0009 9.89242C16.0358 9.89242 16.0703 9.89923 16.1025 9.91244C16.1348 9.92565 16.164 9.94502 16.1887 9.96942C16.2133 9.99383 16.2328 10.0228 16.2461 10.0547C16.2594 10.0865 16.2661 10.1207 16.266 10.1551V11.491C16.2659 11.5286 16.2733 11.5658 16.2878 11.6006C16.3023 11.6354 16.3236 11.667 16.3504 11.6936C16.3773 11.7202 16.4093 11.7414 16.4444 11.7558C16.4796 11.7702 16.5173 11.7776 16.5554 11.7776C16.5934 11.7776 16.6311 11.7702 16.6663 11.7558C16.7015 11.7414 16.7334 11.7202 16.7603 11.6936C16.7872 11.667 16.8084 11.6354 16.8229 11.6006C16.8374 11.5658 16.8448 11.5286 16.8447 11.491V10.8122C16.8375 10.3741 17.5929 10.3739 17.5858 10.8122L17.586 12.5671C17.4789 14.9199 15.4653 15.5674 14.611 15.4151C13.9921 15.3677 12.7017 14.0665 11.2434 12.0189C11.1687 11.9129 11.1308 11.7858 11.1355 11.6568C11.1401 11.5277 11.1872 11.4036 11.2694 11.3032ZM6.79103 12.6955V14.3446L5.01831 12.6955H6.79103ZM18.4213 3.14101H16.3796V1.57943C16.3796 1.31208 16.4872 1.05568 16.6786 0.866638C16.8701 0.677594 17.1297 0.571391 17.4005 0.571391C17.6712 0.571391 17.9309 0.677594 18.1223 0.866638C18.3138 1.05568 18.4213 1.31208 18.4213 1.57943V3.14101Z"
                          stroke="black"
                          stroke-width="2"
                          mask="url(#path-1-inside-1_9140_172)"
                        />
                        <path
                          d="M14.636 4.15026V2.30466C14.6359 2.15317 14.5749 2.00793 14.4664 1.90081C14.3579 1.79369 14.2108 1.73343 14.0574 1.73326H6.3223C6.16888 1.73343 6.0218 1.79369 5.91332 1.90081C5.80484 2.00793 5.74381 2.15317 5.74364 2.30466V4.15026C5.74381 4.30175 5.80484 4.44699 5.91332 4.55411C6.0218 4.66123 6.16888 4.72148 6.3223 4.72165H14.0574C14.2108 4.72148 14.3579 4.66123 14.4664 4.55411C14.5749 4.44699 14.6359 4.30175 14.636 4.15026ZM6.3223 2.30466H14.0574L14.0577 4.15026H6.3223V2.30466Z"
                          stroke="black"
                          stroke-width="2"
                          mask="url(#path-1-inside-1_9140_172)"
                        />
                        <path
                          d="M12.6422 6.12276C12.6422 6.08524 12.6348 6.04808 12.6202 6.01342C12.6057 5.97875 12.5844 5.94725 12.5575 5.92071C12.5306 5.89418 12.4987 5.87313 12.4636 5.85878C12.4285 5.84442 12.3909 5.83704 12.3529 5.83705H6.03297C5.99489 5.83693 5.95717 5.84423 5.92196 5.85854C5.88675 5.87284 5.85475 5.89387 5.82779 5.92041C5.80082 5.94695 5.77943 5.97849 5.76483 6.01321C5.75023 6.04793 5.74272 6.08515 5.74272 6.12275C5.74272 6.16034 5.75023 6.19757 5.76483 6.23229C5.77943 6.26701 5.80082 6.29855 5.82779 6.32509C5.85475 6.35163 5.88675 6.37265 5.92196 6.38696C5.95717 6.40126 5.99489 6.40857 6.03297 6.40845H12.3529C12.3909 6.40846 12.4285 6.40107 12.4636 6.38672C12.4987 6.37237 12.5306 6.35132 12.5575 6.32479C12.5844 6.29826 12.6057 6.26677 12.6202 6.2321C12.6348 6.19744 12.6422 6.16028 12.6422 6.12276Z"
                          stroke="black"
                          stroke-width="2"
                          mask="url(#path-1-inside-1_9140_172)"
                        />
                        <path
                          d="M11.4923 8.54016C11.4923 8.50263 11.4848 8.46548 11.4702 8.43081C11.4557 8.39614 11.4344 8.36464 11.4075 8.33811C11.3807 8.31158 11.3488 8.29053 11.3136 8.27618C11.2785 8.26183 11.2409 8.25445 11.2029 8.25446H6.03297C5.99489 8.25434 5.95717 8.26164 5.92196 8.27595C5.88675 8.29025 5.85475 8.31128 5.82779 8.33782C5.80082 8.36436 5.77943 8.39589 5.76483 8.43062C5.75023 8.46534 5.74272 8.50256 5.74272 8.54016C5.74272 8.57775 5.75023 8.61498 5.76483 8.6497C5.77943 8.68442 5.80082 8.71595 5.82779 8.7425C5.85475 8.76904 5.88675 8.79006 5.92196 8.80437C5.95717 8.81867 5.99489 8.82597 6.03297 8.82585H11.2029C11.2409 8.82587 11.2785 8.81848 11.3137 8.80413C11.3488 8.78977 11.3807 8.76873 11.4075 8.7422C11.4344 8.71567 11.4557 8.68417 11.4703 8.6495C11.4848 8.61483 11.4923 8.57768 11.4923 8.54016Z"
                          stroke="black"
                          stroke-width="2"
                          mask="url(#path-1-inside-1_9140_172)"
                        />
                        <path
                          d="M6.03295 10.6719C5.95721 10.6733 5.88507 10.7041 5.83203 10.7575C5.77899 10.8109 5.74929 10.8828 5.74929 10.9576C5.74929 11.0324 5.779 11.1042 5.83204 11.1576C5.88509 11.211 5.95723 11.2418 6.03297 11.2433H9.66245C9.73819 11.2418 9.81033 11.211 9.86337 11.1576C9.91641 11.1042 9.94611 11.0324 9.94611 10.9576C9.94611 10.8827 9.9164 10.8109 9.86335 10.7575C9.81031 10.7041 9.73817 10.6733 9.66243 10.6719H6.03295Z"
                          stroke="black"
                          stroke-width="2"
                          mask="url(#path-1-inside-1_9140_172)"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_9140_172"
                          x="0"
                          y="0"
                          width="23"
                          height="24"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_9140_172"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_9140_172"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg> */}
                  </span>
                  <strong>Manual Assign</strong>
                </NavLink>
              </li>
            </ul>
          </div>
          {/* )} */}

          <div
            className="w-full agent-content overflow-y-auto"
            // style={{ height: "calc(100vh - 130px)" }}
          >
            <div className="tab-content">
              {/* <div
                style={{
                  display: activeTab === "tab1" ? "block" : "none",
                }}
              >
                Configure 1.
              </div> */}
              {activeTab === "tab2" && monthlyAssign === "monthlyCalender" && (
                <MonthlyCalenderComponent />
              )}
              {activeTab === "tab2" && monthlyAssign === "manualAssign" && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    getAgentData();
                  }}
                >
                  <div>
                    <h5 className="text-[20px] font-[700] pb-[20px]">
                      Manual Assign Tasks
                    </h5>

                    <div className="mb-6">
                      <Label
                        htmlFor="message"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Create Content About / Instructions *
                        <br />
                        <span className="text-[16px] font-[400] italic">
                          Mark can currently generate up to 1,000 words per
                          output.
                        </span>
                      </Label>
                      <textarea
                        className="border rounded-[12px] shadow-sm w-[700px] px-4  border-[#E9EBF0] text-[16px] font-[400]"
                        id="content"
                        name="content"
                        placeholder="Enter"
                        rows={4}
                        required
                        // onChange={(e) => {
                        //   settaskData({ ...taskData, content: e.target.value });
                        // }}
                        onChange={handleChange}
                      />
                    </div>

                    {/* <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="approval"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Select knowledge base
                      </Label>
                      <Select
                        className="bg-[#fff] h-[50px] "
                        id="knowledge_id"
                        // onChange={(e) => {
                        //   settaskData({
                        //     ...taskData,
                        //     knowledge_id: e.target.value,
                        //   });
                        // }}
                        onChange={handleChange}
                      >
                        <option value={""}>Choose Knowledge base</option>
                        {knowLedgeBaseList.map((item, index) => (
                          <>
                            <option value={item?.knowledge_id}>
                              {item?.knowledge_name}
                            </option>
                          </>
                        ))}
                      </Select>
                    </div> */}
                    {/* <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="content_type"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Content Type
                      </Label>
                      <Select
                        className="bg-[#fff] h-[50px]"
                        id="content_type"
                        value={taskData?.content_type}
                        onChange={handleChange}
                      >
                        <option>
                          Choose either user approval required or not
                        </option>
                        <option>Auto Approve</option>
                        <option>User Approve</option>
                        <option>Let Employee Decide</option>
                      </Select>
                    </div> */}
                    <div className="mb-6 w-[700px]">
                      <label
                        className="block text-[20px] font-[400] mb-2"
                        htmlFor="tags"
                      >
                        Enter Keywords *
                      </label>
                      <input
                        type="text"
                        className="border rounded-[12px] shadow-sm w-[700px] border border-[#E9EBF0] px-4 text-[16px] font-[400]"
                        id="keywordSeeds"
                        name="keywordSeeds"
                        placeholder="Enter keywords in comma seperated"
                        value={taskData?.keywordSeeds}
                        onChange={handleChange}
                        required
                      />
                      {/* <div className="flex flex-wrap items-center bg-[#FFFFFF] px-2 py-1 rounded-[15px] border border-gray-300 shadow-md tags-input">
                        {tagskeywords.map((tag, index) => (
                          <div
                            key={index}
                            className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full mr-2 my-1 flex items-center"
                          >
                            {tag}
                            <button
                              className="ml-2 text-white font-bold"
                              onClick={() => removeTagkeywords(index)}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                        <input
                          type="text"
                          className="flex-grow p-2"
                          placeholder="Type and press Enter"
                          value={inputValuekeywords}
                          // required={tagskeywords.length === 0}
                          onChange={(e) =>
                            setInputValuekeywords(e.target.value)
                          }
                          onKeyDown={handleKeyDownkeywords}
                        />
                      </div> */}
                    </div>

                    {/* <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="word_count"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Word Count
                      </Label>
                      <input
                        type="text"
                        className="border rounded-[12px] shadow-sm w-[700px] border border-[#E9EBF0] px-4 text-[16px] font-[400]"
                        id="word_count"
                        name="word_count"
                        placeholder="Enter word count"
                        value={taskData?.word_count}
                        // required
                        // onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div> */}

                    {/* <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="plagiarism_percentage"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Check Plagiarism
                      </Label>
                      <input
                        type="text"
                        className="border rounded-[12px] shadow-sm w-[700px] border border-[#E9EBF0] px-4 text-[16px] font-[400]"
                        id="plagiarism_percentage"
                        name="plagiarism_percentage"
                        placeholder="Enter plagiarism %"
                        value={taskData?.plagiarism_percentage}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div> */}

                    {/* <div
                      className="mb-6 w-[700px] flex items-center"
                      action="/action_page.php"
                    >
                      <p className="text-[20px] font-[400] me-4">
                        Required Human Feedback
                      </p>
                      <input
                        className="me-2"
                        type="radio"
                        id="html"
                        name="fav_language"
                        value="HTML"
                      />
                      <label for="html" className="me-2 text-[12px] font-[400]">
                        Yes
                      </label>

                      <input
                        className="me-2"
                        type="radio"
                        id="css"
                        name="fav_language"
                        value="CSS"
                      />
                      <label for="css" className="me-2 text-[12px] font-[400]">
                        No
                      </label>
                    </div> */}

                    {/* <div
                      className="mb-6 w-[700px] flex items-center"
                      action="/action_page.php"
                    >
                      <input
                        className="me-2"
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        value="Bike"
                      />
                      <label
                        for="vehicle1"
                        className="text-[12px] font-[400] italic"
                      >
                        {" "}
                        Make variations on platforms
                      </label>
                    </div> */}

                    {/* <div className="mb-6 w-[700px]">
                      <div className="flex flex-wrap items-center bg-[#FFFFFF] px-2 py-1 rounded-[15px] border border-gray-300 shadow-md tags-input">
                        {tags.map((tag, index) => (
                          <div
                            key={index}
                            className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full mr-2 my-1 flex items-center"
                          >
                            {tag}
                            <button
                              className="ml-2 text-white font-bold"
                              onClick={() => removeTag(index)}
                            >
                              &times;
                            </button>
                          </div>
                        ))}
                        <input
                          type="text"
                          className="flex-grow p-2"
                          placeholder="Type and press Enter"
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </div> */}

                    {/* <div className="mb-6 w-[700px]">
                    <Label
                      htmlFor="approval"
                      className="mb-2 block text-[20px] font-[400]"
                    >
                      Post Frequency
                    </Label>
                    <Select
                      className="bg-[#fff] h-[50px]"
                      id="countries"
                      required
                    >
                      <option>
                        Choose either user approval required or not
                      </option>
                      <option>Auto Approve</option>
                      <option>User Approve</option>
                      <option>Let Employee Decide</option>
                    </Select>
                  </div> */}

                    {/* <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="post_frequency"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Post Frequency
                      </Label>
                      <input
                        type="text"
                        className="border rounded-[12px] shadow-sm w-[700px] border border-[#E9EBF0] px-4 text-[16px] font-[400]"
                        id="post_frequency"
                        name="post_frequency"
                        placeholder="Enter post frequency"
                        value={taskData?.post_frequency}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div> */}

                    <div className="mb-6 w-[700px]">
                      {/* <label
                      className="block text-[20px] font-[400] mb-2"
                      htmlFor="tags"
                    >
                      Content Repurposer
                    </label> */}

                      {/* <div className="flex flex-wrap items-center bg-[#FFFFFF] px-2 py-1 rounded-[15px] border border-gray-300 shadow-md tags-input">
                      {tagsrepurposer.map((tag, index) => (
                        <div
                          key={index}
                          className="bg-blue-500 text-white text-sm px-3 py-1 rounded-full mr-2 my-1 flex items-center"
                        >
                          {tag}
                          <button
                            className="ml-2 text-white font-bold"
                            onClick={() => removeTagrepurposer(index)}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                      <input
                        type="text"
                        className="flex-grow p-2"
                        placeholder="Type and press Enter"
                        value={inputValuerepurposer}
                        onChange={(e) =>
                          setInputValuerepurposer(e.target.value)
                        }
                        onKeyDown={handleKeyDownrepurposer}
                      />
                    </div> */}
                      {/* <Label
                        htmlFor="approval"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Content Repurposer
                      </Label>
                      <Select
                        className="bg-[#fff] h-[50px] "
                        id="content_repurposer"
                        onChange={handleChange}
                      >
                        <option value={""}>Choose Content Repurposer</option>
                      </Select> */}
                    </div>

                    <div className="mb-6 w-[700px]">
                      <button
                        type="submit"
                        className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 mb-[30px] flex items-center justify-center"
                        disabled={loading}
                        onClick={() => {
                          if (!checkKnowledgeBase()) {
                            return;
                          }
                        }}
                        // onClick={getAgentData}
                      >
                        {loading ? (
                          <div className="flex gap-2 justify-center">
                            <span>Running Task</span>
                            <ThreeDotsLoader />
                          </div>
                        ) : (
                          "Run Task"
                        )}
                      </button>
                    </div>

                    <div className="mb-6 w-[700px] flex items-center justify-center">
                      <button
                        type="button"
                        className="text-[#097BA9] text-[20px] font-[400] flex items-center content-center justify-center hover:text-[#0d4c64]"
                        onClick={() => {
                          setActiveTab("tab3");
                          window?.scrollTo(0, 0);
                        }}
                      >
                        Go to the table to see task status and output
                        <svg className="icon text-[28px] ms-3">
                          <use href="#icon_rightarrow"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </form>
              )}
              {activeTab === "tab3" && (
                <div>
                  <div className="h-full">
                    <EditableTableAgent
                      agentResponseData={agentContents}
                      lastElementRef={lastElementRef}
                      loadingIndividualAgent={loadingIndividualAgent}
                      getAgentData={getAgentData}
                      taskData={taskData}
                      settaskData={settaskData}
                      handleChangeInput={handleChange}
                      handleKeyDownkeywords={handleKeyDownkeywords}
                      inputValuekeywords={inputValuekeywords}
                      removeTagkeywords={removeTagkeywords}
                      setInputValuekeywords={setInputValuekeywords}
                      tagskeywords={tagskeywords}
                      loading={loading}
                      rerunPopup={rerunPopup}
                      setrerunPopup={setrerunPopup}
                      fetchIndividualAgentContent={fetchIndividualAgentContent}
                      checkKnowledgeBase={checkKnowledgeBase}
                    />
                    {loadingAgents && (
                      <div className="flex justify-center mt-4">
                        <Loader />
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: activeTab === "tab4" ? "block" : "none",
                }}
                // className="mt-[-120px]"
              >
                <Chat wordPressDetails={wordPressDetails} reporting={true} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
      <Tooltip
        id="my-tooltip"
        place="bottom"
        delayShow={100}
        className="react-tooltip"
      />
      {/* <ToastContainer /> */}
    </div>
  );
}

export default AiAgentName;
